module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./DrawView.js"));
	}, "DrawView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DrawView!./src/pages/Shop/Draw/DrawView.js
// module id = 892
// module chunks = 438